import type { ReactNode } from 'react';
import { Label } from '@/components/ui/label';

interface AnswerOptionRowProps {
  optionId: string;
  label: string;
  children: ReactNode;
}

export function AnswerOptionRow({ optionId, label, children }: AnswerOptionRowProps) {
  return (
    <div className="flex min-w-0 items-center gap-2.5 rounded-md border bg-card px-3 py-2 text-sm">
      {children}
      <Label htmlFor={optionId} className="min-w-0 cursor-pointer font-normal wrap-break-word">
        {label}
      </Label>
    </div>
  );
}
